<template>
 <v-container class="mr-6 ml-2">
  <v-card width = "960px" 
          height="200px" 
          flat
          class="">
      <v-row>
          <v-card-title>
            <div class="mr-1">
              <strong>{{menu.id}} </strong>
            </div>
          <!-- <strong> -->
            {{menu.name}}
          <!-- </strong> -->
          </v-card-title>
      </v-row>
      <v-row>
          <div class="ml-8">
            {{menu.description}}
          </div>
      </v-row>
      <v-row>     
        <v-spacer></v-spacer>
        <div class="grey--text mr-8">
           {{menu.price}}
        </div>
      </v-row>
      <v-row>
          <v-spacer></v-spacer>
          <v-btn text 
            class="mt-4"    
            :to="{name: 'updateTextCard', params: {menu:  menu}}">Update</v-btn>
      </v-row>
      <v-divider class="mt-2"></v-divider>
     
  </v-card>
  </v-container>
</template>

<script>
export default {
    name: "tcard",
    props: ['menu']

}
</script>

<style>

</style>